import { render, staticRenderFns } from "./hostadd.vue?vue&type=template&id=69c00d3a&"
import script from "./hostadd.vue?vue&type=script&lang=js&"
export * from "./hostadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports